import styled, { css } from 'styled-components';
import { color, bg } from '@lendi-ui/color';
import { KeyboardArrowDown } from '@lendi-ui/icon';
import { mx, my, px, p } from '@lendi-ui/spacing';
import { body, heading } from '@lendi-ui/typography';
import { display } from '@lendi-ui/utils';
import { gte } from '@lendi-ui/breakpoint';
import { depth } from '@lendi-ui/depth';

export interface DrawerProps {
  show: boolean;
  toggleDrawer: () => void;
}

interface WrapperProps {
  show: boolean;
}

interface DownProps {
  onClick: () => void;
}

export const Wrapper = styled.div`
  ${bg('secondary.500')}
  width: 100%;
  position: fixed;
  bottom: 0;
  display: flex;
  flex-direction: column;
  box-sizing: unset;
  ${({ show }: WrapperProps) =>
    show
      ? css`
          ${Container} {
            max-height: 190px;
            ${my('sm')}
          }
          ${PreviewTitle} {
            display: none;
            ${my('nil')}
          }
          ${DownIcon} {
            box-shadow: none;
          }
        `
      : css`
          ${Container} {
            max-height: 0px;
          }
          ${DownIcon} > svg {
            transform: rotate(180deg);
          }
        `}
`;

export const Container = styled.section`
  ${px({ mobile: 'nil', tablet: 'sm' })}
  ${mx('auto')}
  width: 100%;
  max-width: 48rem;
  align-items: center;
  display: flex;
  overflow: hidden;
  transition: max-height 500ms ease-in-out;
  ${gte('desktop')`
    width: auto;
  `}
`;

export const DownIcon = styled(KeyboardArrowDown)<DownProps>`
  ${mx('auto')}
  ${bg('secondary.500')}
  ${body({ color: 'shade.0' })}
  ${p('xxs')}
  ${depth(4)}
  margin-top: -20px;
  width: 20px;
  height: 20px;
  border-radius: 32px;
  border: 1.5px solid ${color('shade.0')};
  cursor: pointer;
  svg {
    pointer-events: none;
  }
`;

export const PreviewTitle = styled.div`
  ${body({ size: 'sm', color: 'shade.0' })}
  ${mx('auto')}
  ${my('xs')}
  transition: max-height 500ms ease-in-out;
`;

export const Image = styled.img`
  ${display({ mobile: 'none', tablet: 'block' })}
  border-radius: 6px;
  width: 25%;
`;

export const Content = styled.section`
  ${px('sm')}
  width: 100%;
  ${gte('desktop')`
    width: 75%;
  `}
  > a {
    width: 100%;
    ${gte('tablet')`
      width: auto;
  `}
  }
`;

export const Heading = styled.h2`
  ${heading({ size: 'sm', color: 'shade.0' })}
  ${my('nil')}
`;

export const Paragraph = styled.p`
  ${body({ size: 'sm', color: 'shade.0' })}
`;

export const DrawerSpacer = styled.div`
  ${gte('mobile')`
    height: 54px;
  `}
  ${gte('tablet')`
    height: 60px;
  `}
`;
